module.exports = __webpack_public_path__ + "socialTwo-c92cbb571ef6b06fa303853424365da8.png";